/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import CustomLocation from "./CustomLocation";
import PresetLocation from "./PresetLocation";

const EditLocation = props => {
  const { location, locations, errors } = props;
  const locationType = location.type.code;
  // in this case, if the type has change then we probably need to blitz the
  // location and start again, otherwise it could force unwanted editing of
  // existing locations
  const handleTypeChange = obj => {
    props.handleLocationTypeChange(obj);
  };

  if (locationType === "CUSTOM" || locationType === "JOB") {
    return (
      <CustomLocation
        errors={errors}
        location={location}
        handleLocationTypeChange={handleTypeChange}
        handleChange={props.handleLocationChange}
      />
    );
  }

  return (
    <PresetLocation
      errors={errors}
      location={location}
      locations={locations}
      handleLocationTypeChange={handleTypeChange}
      handleChange={props.handleLocationChange}
    />
  );
};
EditLocation.propTypes = {
  location: PropTypes.object.isRequired,
  locations: PropTypes.array.isRequired,
  errors: PropTypes.array.isRequired,
  handleLocationTypeChange: PropTypes.func.isRequired,
  handleLocationChange: PropTypes.func.isRequired
};

export default EditLocation;



// WEBPACK FOOTER //
// ./src/forms/fields/EditLocation.js